// Template Generated by DataExtraction.py at 1717541024

import ADULTCLBEnglish1 from "../../Forms/CESG/ADULTCLB_English1.png";
import ADULTCLBEnglish1Labels from "../../Labels/CESG/ADULTCLB_English1.json";
import ADULTCLBFrench1 from "../../Forms/CESG/ADULTCLB_French1.png";
import ADULTCLBFrench1Labels from "../../Labels/CESG/ADULTCLB_French1.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel,
    signatureTab, isFemale, isMale, drawText as drawTextAtPos, isAnotherGender
} from "../../PDFGenerationUtils";
import { POSSIBLE_SIGNERS } from "../../../Utils/PlanUtils";

import moment from "moment/moment";
import { t } from "i18next";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? ADULTCLBFrench1Labels : ADULTCLBEnglish1Labels;
    const formImage = isFrench ? ADULTCLBFrench1 : ADULTCLBEnglish1;

    function fillCheckbox(value, label) {
        fillCheckboxAtLabel(doc, value, label, labels);
    }

    function drawText(value, label) {
        drawTextOnLabel(doc, value, label, labels);
    }

    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */

    const subscriber = data.subscriber;
    const jointSubscriber = data.jointSubscriber;

    const subscriber2Include = data.common.subscriber2Include;

    const format = "yyyy/MM/DD";
    const beneficiary = data.beneficiary;

    const beneficiaryBirthdateYyyyMmDd = moment(beneficiary.birthdate).format(format);
    const now = moment().format(format);



    // drawTextAtPos(doc, 12, t("Children's Education Funds Inc."), 53 / 3.38, 300 / 3.38, 454 / 3.38);
    drawText(t("Children's Education Funds Inc."), "respProvider")

    let pcgSin;

    if (subscriber.primaryCaregiver) {
        pcgSin = subscriber.sin;
    } else if (subscriber2Include && jointSubscriber.primaryCaregiver) {
        pcgSin = jointSubscriber.sin;
    } else {
        pcgSin = "";
    }

    let isIndependant = pcgSin == beneficiary.sin;

    fillCheckbox(isIndependant, "checkIndependent"); // TODO ?
    drawText(beneficiaryBirthdateYyyyMmDd, "beneficiaryBirthdateYyyyMmDd");
    fillCheckbox(isFemale(beneficiary.gender), "beneficiaryFemale");
    drawText(beneficiary.firstName, "beneficiaryFirstName");
    drawText(beneficiary.lastName, "beneficiaryLastName");
    fillCheckbox(isMale(beneficiary.gender), "beneficiaryMale");
    fillCheckbox(isAnotherGender(beneficiary.gender), "beneficiaryAnother")
    drawText(beneficiary.sin, "beneficiarySIN");
    drawText(now, "beneficiarySignDateYyyyMmDd");

}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? ADULTCLBFrench1Labels : ADULTCLBEnglish1Labels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    let signers = [];
    let signHereTabs = [];

    const subscriber = state.subscriber;
    const jointSubscriber = state.jointSubscriber;
    const beneficiary = state.beneficiary;
    const subscriber2Include = state.common.subscriber2Include

    let beneSignerID = POSSIBLE_SIGNERS['Beneficiary']; // TODO not real talk to greg!

    if (subscriber.primaryCaregiver) {
        if (subscriber.sin == beneficiary.sin) {
            beneSignerID = subscriberRecipientId;
        }
    } else if (subscriber2Include && jointSubscriber.primaryCaregiver) {
        if (jointSubscriber.sin == beneficiary.sin) {
            beneSignerID = jointSubscriberRecipientId;
        }
    }

    // BeneficiarySignature
    signers.push({
        [beneSignerID]: [signatureTab(beneSignerID, documentId, pageNumber, signatureLabel("BeneficiarySignature", labels))],
    });


    return signers;
}

export default {
    generate,
    signatureDefinitions
}
